import { render, staticRenderFns } from "./DispatchHistory.vue?vue&type=template&id=abcbc018&scoped=true&"
import script from "./DispatchHistory.vue?vue&type=script&lang=js&"
export * from "./DispatchHistory.vue?vue&type=script&lang=js&"
import style0 from "./DispatchHistory.vue?vue&type=style&index=0&id=abcbc018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcbc018",
  null
  
)

export default component.exports